module.exports = __webpack_public_path__ + "img/nounawards.6152d0aa.svg";